import React, { useState, useEffect } from "react";

// components
import CustomPagination from "components/CustomPagination ";

// packages
import { Modal } from "react-bootstrap";
import parse from "html-react-parser";

// hooks
import { useGetQuestions } from "hooks/api/subject";
import { useTable } from "hooks/custom/useTable";

const QuestionsModal = ({
  type,
  board_id,
  class_id,
  subject_id,
  selectedChapters,
  selectedQuestions,
  setSelectedQuestions,
  selectedTopics,
  maxMarks
}) => {
  const [modal, setModal] = useState(false);
  const [rows, setRows] = useState([]);

  const { data: questions } = useGetQuestions();

  useEffect(() => {
    if (questions?.data) {
      const data = filterArray(
        { board_id, class_id, subject_id, type },
        questions?.data
      );

      // setRows(
      //   data.filter((ele) =>
      //     selectedChapters?.length > 0
      //       ? selectedChapters.includes(ele.chapter_id) && ele.status == 1
      //       : ele.status == 1
      //   )
      // );
      setRows(
        data.filter((ele) => {
          if (selectedChapters?.length > 0) {
            console.log(selectedChapters);
            console.log("Inside Chapters Block");
            if (selectedTopics?.length > 0) {
            console.log("Inside Topics Block");
            console.log(selectedTopics);
              return (
                selectedChapters.includes(ele.chapter_id) &&
                selectedTopics.includes(ele.topic_id) &&
                ele.status == 1
              );
            }
            return (
              selectedChapters.includes(ele.chapter_id) && ele.status == 1
            );
          }
          console.log("Before All Status 1");
          return ele.status == 1;
        })
      );
    }
  }, [
    questions?.data,
    board_id,
    class_id,
    subject_id,
    JSON.stringify(selectedChapters),
    selectedTopics
  ]);

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable();

  const handleClose = () => setModal(false);

  // Calculate total marks of selected questions
  const totalMarks = selectedQuestions.reduce((sum, q) => {
    return sum + (parseFloat(q.marks) || 0);
  }, 0);

  return (
    <>
      <button
        className="btn btn-primary ml-auto"
        onClick={() => setModal(true)}
      >
        Add Questions
      </button>

      <Modal size="xl" centered show={modal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Select Questions</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {maxMarks !== null && maxMarks !== undefined && (
            <div className={`alert ${totalMarks > maxMarks ? 'alert-danger' : totalMarks >= maxMarks ? 'alert-warning' : 'alert-info'}`} style={{ marginBottom: "15px" }}>
              <strong>Marks Limit:</strong> Maximum marks allowed: <strong>{maxMarks}</strong>. 
              Currently selected: <strong>{totalMarks.toFixed(1)} / {maxMarks}</strong>
              {totalMarks > maxMarks && (
                <span style={{ display: "block", marginTop: "5px" }}>
                  ⚠️ Total marks exceed the limit. Please deselect questions to reduce the total.
                </span>
              )}
            </div>
          )}
          <div className="body table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Select</th>
                  <th>Question</th>
                  <th>Marks</th>
                  <th>CHAPTER</th>
                  <th>TOPIC</th>
                </tr>
              </thead>
              <tbody>
                {rows
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row) => {
                    const isSelected = selectedQuestions.filter(
                      (ele) => ele?.id === row?.id
                    ).length > 0;
                    const questionMarks = parseFloat(row.marks) || 0;
                    const wouldExceedLimit = maxMarks !== null && maxMarks !== undefined && 
                      !isSelected && (totalMarks + questionMarks) > maxMarks;
                    
                    return (
                      <tr key={row.id}>
                        <td style={{ width: "60px" }}>
                          <div className="form-group">
                            <label className="fancy-checkbox">
                              <input
                                name="checkbox"
                                type="checkbox"
                                checked={isSelected}
                                disabled={wouldExceedLimit}
                                onChange={(value) => {
                                  const exist = selectedQuestions.filter(
                                    (ele) => ele.id === row.id
                                  );

                                  if (exist.length > 0) {
                                    setSelectedQuestions(
                                      selectedQuestions.filter(
                                        (ele) => ele.id !== row.id
                                      )
                                    );
                                  } else {
                                    // Check if adding this question would exceed the max marks limit
                                    if (maxMarks !== null && maxMarks !== undefined) {
                                      const newTotalMarks = totalMarks + questionMarks;
                                      if (newTotalMarks > maxMarks) {
                                        alert(`Cannot select this question. Total marks would be ${newTotalMarks.toFixed(1)}, which exceeds the limit of ${maxMarks}.`);
                                        return;
                                      }
                                    }
                                    setSelectedQuestions([
                                      ...selectedQuestions,
                                      row,
                                    ]);
                                  }
                                }}
                              />
                              <span></span>
                            </label>
                          </div>
                        </td>
                        <td>{parse(`${row.question}`)}</td>
                        <td>{row.marks || 0}</td>
                        <td>{row.chapter_name}</td>
                        <td>{row.topic_name}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="body" style={{ paddingTop: 0, paddingBottom: 0 }}>
            <CustomPagination
              count={rows.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default QuestionsModal;

const removeNullValues = (obj) => {
  for (let key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    }
  }
  return obj;
};

const filterArray = (filterObj, data) => {
  console.log("data: filter", data);
  console.log("filterObj filter: ", filterObj);
  const obj = removeNullValues({ ...filterObj });

  const filteredArray = data.filter((item) => {
    let match = true;
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (item[key] != obj[key]) {
          match = false;
          break;
        }
      }
    }
    return match;
  });

  return filteredArray;
};
